import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthed } from "../lib/auth";

// Wrap admin routes with <RequireAuth>...</RequireAuth>.
// Unauthenticated visitors are bounced to /products (NOT to the login page)
// so the existence of the admin panel stays hidden. Only visitors who know the
// secret login URL can reach the login form.
export default function RequireAuth({ children }) {
  const loc = useLocation();
  if (!isAuthed()) {
    return <Navigate to="/products" replace state={{ from: loc.pathname }} />;
  }
  return children;
}
